import UnitInfoModal from '../deprecated/UnitInfoModal';
import UnitPriceModal from '../deprecated/UnitPriceModal';
import CartHighFiveModal from './CartHighFiveModal';
import CartHighFiveAccomodationModal from './CartHighFiveAccomodationModal';
import AccomodationCompareShare from './AccomodationCompareShare';
import CheckoutLoginModal from './CheckoutLoginModal';
import DatepickerRangeModal from './DatepickerRangeModal';
import GeneralModal from './GeneralModal';
import SkiRentalPickDate from './SkiRentalPickDate';
import SkiPassPickDate from './SkiPassPickDate';
import SkiPassPickDateKeycard from './SkiPassPickDateKeycard';
import TimeoutModal from './TimeoutModal';
import SkiPassRefill from './SkiPassRefill';
import SkiRentalCategories from './SkiRentalCategories';
import SkiRentalWishes from './SkiRentalWishes';
import SkiRentalFoot from './SkiRentalFoot';
import AddonInfoModal from './AddonInfoModal';
import SkipassInfo from './SkipassInfo';
import MapModalkungsberget from './MapModalkungsberget';
import MapModalbranas from './MapModalbranas';
import MovieModal from './MovieModal';
import AccomodationSkipass from './AccomodationSkipass';
import SkiSchoolLocationMap from './SkiSchoolLocationMap';
import SkiSchoolFaq from './SkiSchoolFaq';
import SkiSchoolInfo from './SkiSchoolInfo';
import SkiSchoolBooking from './SkiSchoolBooking';
import SkiSchoolPicker from './SkiSchoolPicker';
import SkiRentalConfirm from './SkiRentalConfirm';
import SummerConfirmationModal from './SummerConfirmationModal';
import OnSitePayment from './OnSitePayment';
import RutModal from './RutModal';
import IncludedInPriceModal from './IncludedInPriceModal';
import SkipassPrices from './SkipassPrices';
import CreatingOrder from './CreatingOrder';
import SecondAccomodationModal from './SecondAccomodationModal';
import SkiPassConfirm from './SkiPassConfirm';
import BookingCancelled from './BookingCancelled';
import ReclaimReservationsModal from './ReclaimReservationsModal';
import AdminSyncFields from './AdminSyncFields';
import QrModal from './QrModal';
import SlideshowModal from './SlideshowModal';

export default {
  UnitInfoModal,
  UnitPriceModal,
  CartHighFiveModal,
  CartHighFiveAccomodationModal,
  AccomodationCompareShare,
  CheckoutLoginModal,
  DatepickerRangeModal,
  GeneralModal,
  SkiRentalPickDate,
  SkiPassRefill,
  SkiPassPickDate,
  SkiPassPickDateKeycard,
  TimeoutModal,
  SkiRentalWishes,
  SkiRentalFoot,
  SkiRentalCategories,
  AddonInfoModal,
  SkipassInfo,
  MapModalbranas,
  MapModalkungsberget,
  MovieModal,
  AccomodationSkipass,
  SkiSchoolLocationMap,
  SkiSchoolFaq,
  SkiSchoolInfo,
  SkiSchoolBooking,
  SkiSchoolPicker,
  SkiRentalConfirm,
  OnSitePayment,
  RutModal,
  IncludedInPriceModal,
  SkipassPrices,
  CreatingOrder,
  SecondAccomodationModal,
  SkiPassConfirm,
  BookingCancelled,
  ReclaimReservationsModal,
  AdminSyncFields,
  SummerConfirmationModal,
  QrModal,
  SlideshowModal,
};



// WEBPACK FOOTER //
// ./src/components/modals/index.js